import firebase from "../../../config/firebase";

// Actions

// upload image to cloud storage
export const uploadImage = async (file, companyEmail) => {
  console.log("upload called----", file);
  const storageRef = firebase.storage().ref();
  const fileRef = storageRef.child(`${companyEmail}/${file.name}`);
  await fileRef.put(file);
  return fileRef.getDownloadURL();
};
